const useStyles = theme => ({
    rowContainer: {
      paddingLeft:10,
      paddingRight: 10,
    },
    mainTitle: {
      display: "-webkit-box",
      boxOrient: "vertical",
      lineClamp: 2,
      wordBreak: "break-word",
      overflow: "hidden",
      marginRight: 30,
      marginLeft: 25,
      marginTop: 15,
      [theme.breakpoints.only('md')]: {
        marginRight: 20,
        marginLeft: 20,
        marginTop: 25,
        lineClamp: 2,
      },
      [theme.breakpoints.down('sm')]: {
        marginTop: 10,
        marginRight: 10,
        marginLeft: 15,
        lineClamp: 3,
      },
    },
    secondaryTitle: {
      display: "-webkit-box",
      boxOrient: "vertical",
      lineClamp: 2,
      wordBreak: "break-word",
      overflow: "hidden",
      marginLeft: 25,
      marginRight: 20,
      marginTop: 15,
      [theme.breakpoints.only('md')]: {
        marginRight: 25,
        marginLeft: 20,
      },
    },
});

export default useStyles
